// src/screens/sales/complexOrder/hooks/useComplexOrder.ts

import { useCallback, useState, useEffect } from 'react'
import { ComplexOrderInterface } from '../../../../common/types/interfaces'
import { getSalesApi } from '../../../../salesApi/salesApi'
import { useDispatch, useSelector } from 'react-redux'

import { ComplexOrderStatus } from '../../../../common/types/enums'
import {
  selectComplexOrderList,
  setComplexOrderList,
} from '../../../../store/slices/complexOrderListSlice'

export const initialData: ComplexOrderInterface = {
  status: ComplexOrderStatus.DRAFT as ComplexOrderStatus,
  total: 0,
  phone_number: '',
  customerName: '',
  notes: '',
  items: [] as Array<{
    itemId: number
    name: string
    quantity: number
    basePrice: number
    manualPrice?: number
    total: number
  }>,
  data: [] as Array<{
    fieldTemplateId?: number
    type: string
    value: string
    label?: string
  }>,
}

export const useComplexOrder = () => {
  const [modalActive, setModalActive] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false)
  const [salesApi] = useState(getSalesApi())
  const [data, setData] = useState<ComplexOrderInterface>()
  const [detailsModalActive, setDetailsModalActive] = useState<boolean>(false)
  const [current, setCurrent] = useState<ComplexOrderInterface>()
  const list = useSelector(selectComplexOrderList)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  const getList = useCallback(async () => {
    try {
      const result = await salesApi.getComplexOrderList({ sort: 'id', order: 'DESC' })
      setLoading(false)
      if (result) dispatch(setComplexOrderList(result))
    } catch (error) {
      setLoading(false)
    }
  }, [salesApi, dispatch])

  const startEdit = (el: ComplexOrderInterface) => {
    if (detailsModalActive) setDetailsModalActive(false)
    setCurrent({ ...el })
    setEdit(true)
    setModalActive(true)
  }

  const startCreate = () => {
    setCurrent(undefined)
    setModalActive(true)
  }

  const showDetails = useCallback((el: ComplexOrderInterface) => {
    setCurrent(el)
    setDetailsModalActive(true)
  }, [])

  useEffect(() => {
    getList()
  }, [getList])

  useEffect(() => {
    if (!modalActive) setData(undefined)
  }, [modalActive])

  return {
    getList,
    modalActive,
    setModalActive,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    initialData,
    startCreate,
    loading,
  }
}
